import React from "react";
import { Stack, Divider, Grid, Box, Typography } from "@mui/material";
import { useFormContext, Controller } from "react-hook-form";
import { TextInput } from "./Inputs";
import RadioInput from "./Inputs/RadioInput";
import "./TextArea.css";

interface ReviewSectionProps {
  fieldPrefix: string; // e.g. "review.applicantInfo"
  defaultStatus?: number;
  extra?: React.ReactNode | null; // Optional extra content
  canApprove?: boolean; // New prop to control visibility of the section
  canViewReview?: boolean;
  canViewWSResult?: boolean; // New prop to control visibility of the section
}

const ReviewSection: React.FC<ReviewSectionProps> = ({
  fieldPrefix,
  defaultStatus = 1,
  extra = null,
  canApprove = false, // Added canApprove prop
  canViewReview = false,
  canViewWSResult = false,
}) => {
  const { control, getValues, register } = useFormContext();
  const status = getValues(`${fieldPrefix}.status`);
  const comments = getValues(`${fieldPrefix}.comments`);

  const statusLabels: Record<number, string> = {
    2: "ΑΠΟΔΕΚΤΟ",
    3: "ΜΗ ΑΠΟΔΕΚΤΟ",
  };

  const statusColors: Record<number, string> = {
    2: "#66BB6A", // Green
    3: "#EF5350", // Red
  };

  if (canApprove)
    return (
      <Stack direction="column" spacing={2} sx={{ width: "100%" }}>
        <Divider sx={{ borderWidth: 1 }} />

        <Grid container sx={{ gap: 2 }}>
          {extra}

          <Grid item xs={12}>
            <Controller
              name={`${fieldPrefix}.status`}
              control={control}
              defaultValue={defaultStatus}
              render={({ field }) => (
                <RadioInput
                  labelWidth={100}
                  rowDirection="row"
                  name={field.name}
                  label="Κατάσταση"
                  defaultValue={field.value}
                  changeFn={(e: any) => field.onChange(e.target.value)}
                  options={[
                    { Value: 1, Label: "Σε έλεγχο" },
                    { Value: 2, Label: "Αποδεκτό" },
                    { Value: 3, Label: "Μη αποδεκτό" },
                  ]}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <textarea
              {...register(`${fieldPrefix}.comments`)}
              rows={3}
              placeholder="Σχόλια"
              className="custom-textarea"
            />
          </Grid>
        </Grid>
      </Stack>
    );

  const numericStatus = Number(status);
  const label = statusLabels[numericStatus] ?? "";
  const color = statusColors[numericStatus] ?? "";

  if (label && canViewReview)
    return (
      <Stack direction="column" spacing={2} sx={{ width: "100%" }}>
        <Divider sx={{ borderWidth: 1 }} />
        {canViewWSResult && extra}
        <Box
          sx={{
            p: 2,
            border: `1px solid ${color}`,
            borderRadius: 1,
            backgroundColor: "#f9f9f9",
          }}
        >
          <Typography variant="subtitle1" sx={{ color, fontWeight: "bold" }}>
            {label}
          </Typography>
          {comments && (
            <Typography variant="body1" sx={{ mt: 1, whiteSpace: "pre-line" }}>
              {comments}
            </Typography>
          )}
        </Box>
      </Stack>
    );
};

export default ReviewSection;
